import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { OperationentityCollectionCatagoryMapping, OperationentityCollectionCatagoryMappingAddEdit } from './Pages';

export const OperationentityCollectionCatagoryMappingRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={OperationentityCollectionCatagoryMapping} />
        <Route exact path = {`${match.path}/AddEdit`} component={OperationentityCollectionCatagoryMappingAddEdit} />
    </Fragment>
)